/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false,
  standalone: false,
})
export class Filter<T> implements PipeTransform {
  transform(data: T[], property: keyof T, value: string) {
    const filteredData = data.filter((item) => {
      if (item && item[property]) {
        if (Array.isArray(value) && value.length) {
          return value.includes(String(item[property]));
        } else {
          return item[property] === value;
        }
      }
      return false;
    });
    return filteredData;
  }
}
